import React from 'react';

import { article as ArticlePropType } from 'lib/CustomPropTypes';
import { TAX_CONSTANTS, extractTermPaths } from 'lib/taxonomy';

import { RecircEnd as MsnbcDailyRecirc } from 'components/MsnbcDaily/Recirc/End';

function ArticleFoot({ article }) {
  const {
    taxonomy,
    presentation: {
      hideRecommendations,
    },
  } = article;

  const termPaths = extractTermPaths(taxonomy);

  return (
    <>
      {!hideRecommendations
      && termPaths.includes(TAX_CONSTANTS.MSNBC.VERTICAL)
      && termPaths.includes(TAX_CONSTANTS.MSNBC.SECTION_OPINION) && (
        <MsnbcDailyRecirc />
      )}
    </>
  );
}

ArticleFoot.propTypes = {
  article: ArticlePropType.isRequired,
};

export { ArticleFoot };
